var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Information.module.css';
import { useState } from 'react';
import { RateAccordion } from './RateAccordion';
import { Promo } from './Promo';
import { useApplication } from '../../Contexts/ApplicationContext';
var SHORT_FEE_DETAILS_LENGTH = 1;
export var Information = function () {
    var _a;
    var _b = useState(false), isAccordionOpen = _b[0], setIsAccordionOpen = _b[1];
    var exchangeInfo = useApplication().orderFacade.exchangeInfo;
    var handleToggleAccordion = function () { return setIsAccordionOpen(function (state) { return !state; }); };
    var exchangeInfoFeeDetails = (_a = exchangeInfo.fee) === null || _a === void 0 ? void 0 : _a.details;
    var isPromoHidden = exchangeInfoFeeDetails
        ? exchangeInfoFeeDetails.length > SHORT_FEE_DETAILS_LENGTH
        : false;
    var promoState = isAccordionOpen && isPromoHidden
        ? 'hidden'
        : isAccordionOpen && !isPromoHidden
            ? 'small'
            : 'big';
    var wrapperClassName = "".concat(styles.wrapper, " ").concat(isAccordionOpen ? styles.open : '', "\n  ").concat(isAccordionOpen && isPromoHidden ? styles.wrapper_full : '');
    return (_jsxs("div", __assign({ className: wrapperClassName }, { children: [_jsx(RateAccordion, { exchangeInfo: exchangeInfo, toggleAccordion: handleToggleAccordion }), _jsx(Promo, { promoState: promoState })] })));
};
